export function addPaddingToHeader() {
  const siteNav = document.querySelector('#site-nav');
  const header = document.querySelector('header');
  const firstSection = header.nextElementSibling;
  const siteNavHeight = siteNav.offsetHeight;

  firstSection.style.marginBlockStart = `${siteNavHeight}px`;
}